<template>
<e-chart ref="chart" />
</template>

<script>
import ChartStyle from '../DataChart/ChartStyle'
export default {
  name: 'DayNightLineChart',
  props: {
    data: {
      required: true,
      type: Object
    }
  },
  data: () => ({
    currentLegendIndex: 0
  }),
  computed: {
    COLORS: () => ChartStyle.COLORS
  },
  methods: {
    getRenderData () {
      let {dataList, dimensions, unitProp} = this.data
      let dataTimes = dataList.map(el => el.dataTime)
      let series = dimensions.reduce((map, el) => {
        map[el.id] = {
          name: el.name,
          type: 'line',
          yAxisIndex: 0,
          showSymbol: false,
          data: []
        }

        return map
      }, {})

      dataList.forEach(el => {
        for (let key in el) {
          if (series[key]) {
            series[key].data.push({
              value: el[key],
              isHaveIntegral: el[key + 'Flag'] ? el[key + 'Flag'] : false,
              dataTime: el.dataTime
            })
          }
        }
      })

      let yAxis = dimensions.reduce((map, el) => {
        if (!map[el[unitProp]]) {
          map[el[unitProp]] = {
            name: el[unitProp],
            type: 'value',
            nameTextStyle: {
              color: 'RGB(96, 98, 102)'
            },
            axisLabel: {
              show: true,
              inside: false,
              color: 'RGB(96, 98, 102)'
            },
            axisLine: {
              show: true,
              lineStyle: 'RGB(96, 98, 102)'
            }
          }
        }
        return map
      }, {})

      let yAxisData = Object.values(yAxis).length > 0 ? Object.values(yAxis).map((el, i) => {
        if (i <= 1) {
          return {...el}
        } else {
          return {...el, offset: 30}
        }
      }) : [{
        type: 'value',
        nameTextStyle: {
          color: 'RGB(96, 98, 102)'
        },
        axisLabel: {
          show: true,
          inside: false,
          color: 'RGB(96, 98, 102)'
        },
        axisLine: {
          show: true,
          lineStyle: 'RGB(96, 98, 102)'
        }
      }]

      dimensions.forEach(el => {
        let index = yAxisData.findIndex(item => item.name === el[unitProp])
        if (series[el.id]) {
          series[el.id].data.forEach(item => {
            item.unit = el[unitProp]
          })
          series[el.id].yAxisIndex = index
        }
      })

      return {
        series: Object.values(series),
        dataTimes: dataTimes,
        yAxisData: yAxisData
      }
    },
    computedMaxMin (data) {
      let allData = data.series.map(el => {
        let seriesData = el.data.map(item => item.value)

        return seriesData
      })
      let temp = allData.flat().filter(el => el !== '--')
      let max = Math.max.apply(null, temp)
      let min = Math.min.apply(null, temp)
      return {
        min: min,
        max: max
      }
    },
    render (isReal) {
      let data = this.getRenderData()
      let maxmin = this.computedMaxMin(data)
      let {min, max} = maxmin

      let chartOpt = {
        toolbox: {
          feature: {
            saveAsImage: {}
          },
          right: 10
        },
        legend: {
          width: '80%',
          type: 'scroll'
        },
        tooltip: {
          show: true,
          trigger: 'axis',
          formatter: params => {
            const E_CHART_MAX_ROWS = process.env.E_CHART_MAX_ROWS
            let columns = Math.ceil(params.length / E_CHART_MAX_ROWS)
            let add = 1

            return `<div class="e-chart-tooltip" style="--e-chart-tooltip-columns:${columns}"><div class="e-chart-tooltip-name">${params[0].name}</div><div class="e-chart-tooltip-content">${params.map(({marker, seriesName, value, data}, index) => {
              return `${marker}<span class="e-chart-tooltip-series-name">${seriesName}:</span><span class="e-chart-tooltip-value ${((index + add) % columns) === 0 ? '' : 'e-chart-tooltip-value-space'}">${Number.isFinite(value) ? Number(value.toFixed(3)) : '--'}${data.unit}${(data && data.isHaveIntegral) ? '(重积分)' : ''}</span>`
            }).join('')}</div></div>`
          }
        },
        grid: [{
          top: 60,
          right: 30,
          bottom: 10,
          left: 30,
          containLabel: true
        }],
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: data.dataTimes
        },
        yAxis: data.yAxisData.map(el => {
          return {
            ...el,
            max: typeof max === 'number' && !isNaN(max) ? Math.ceil(max * 1.05 * 10) / 10 : '',
            min: typeof max === 'number' && !isNaN(min) ? Math.floor(min * 0.95 * 10) / 10 : ''
          }
        }),
        color: this.COLORS,
        series: data.series
      }
      let that = this
      this.$refs.chart.setOpt(chartOpt)
      this.$refs.chart.myChart.off('legendselectchanged')
      this.$refs.chart.myChart.off('legendscroll')
      this.$refs.chart.myChart.on('legendselectchanged', function (params) {
        let allData = data.series.map(el => {
          let seriesData = el.data.map(item => item.value)
          if (params.selected[el.name]) {
            return seriesData
          }

          return []
        })

        let temp = allData.flat().filter(el => el !== '--')
        let max = Math.max.apply(null, temp)
        let min = Math.min.apply(null, temp)
        let newChartOpt = JSON.parse(JSON.stringify(chartOpt))

        newChartOpt.legend.selected = params.selected
        newChartOpt.legend.scrollDataIndex = that.currentLegendIndex ? that.currentLegendIndex : 0
        newChartOpt.yAxis = newChartOpt.yAxis.map(el => {
          return {
            ...el,
            max: typeof max === 'number' && !isNaN(max) ? Math.ceil(max * 1.05 * 10) / 10 : '',
            min: typeof max === 'number' && !isNaN(min) ? Math.floor(min * 0.95 * 10) / 10 : ''
          }
        })

        that.$refs.chart.setOpt(newChartOpt)
      })

      this.$refs.chart.myChart.on('legendscroll', (params) => {
        that.currentLegendIndex = params.scrollDataIndex
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Data/DayNightLineChart.vue